<template>
  <v-main :anchor-layout="layoutName">
    <v-container class="fill-height grey darken-4" fluid >
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="4">
          <router-view v-if="applicationLoaded"></router-view>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script lang="babel" type="text/babel">
import layoutMixin from 'layouts/layoutMixin.js'
export default {
  mixins: [layoutMixin],
  data() {
    return {
      layoutName: 'unauthorized-admin',
    }
  },
  created() {
    this.$ssr()
    this.setupLayout()
    this.checkIdentity()
  },
  methods: {
    checkIdentity() {
      if(!this.isUser) return
      this.$router.replace({
        name: 'admin.home',
      })
    },
  },
  watch: {
    isUser() {
      this.checkIdentity()
    },
  },
}
</script>

<style lang="sass" type="text/sass" scoped></style>